import type { Plugin, Context } from '@segment/analytics-next';

const handleEvent = (ctx: Context) => {
  if (!window?.QuantumMetricAPI?.handleSegmentTrackEvents) {
    return ctx;
  }

  if (ctx.event.type === 'track') {
    window.QuantumMetricAPI.handleSegmentTrackEvents(
      ctx.event.event,
      ctx.event.properties,
    );
  }

  if (ctx.event.type === 'page') {
    window.QuantumMetricAPI.handleSegmentPageEvents(
      ctx.event.event,
      ctx.event.properties,
      ctx.event.properties,
    );
  }

  return ctx;
};

/**
 *
 */
const quantumMetricPlugin: Plugin = {
  name: 'quantumMetricPlugin',
  type: 'destination',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: handleEvent,
  page: handleEvent,
  identify: (ctx) => ctx,
  alias: (ctx) => ctx,
  group: (ctx) => ctx,
  screen: (ctx) => ctx,
};

export default quantumMetricPlugin;
